/* kjv-home.js — comportamento das seções da home do clone da Kojeva.
   Modal de vídeo, galeria do produto em destaque (miniaturas + arraste + lightbox),
   stepper de quantidade e botão de compartilhar. O Add to cart é do tema:
   o form leva data-dd-add e o theme.js adiciona via AJAX e abre a gaveta do carrinho. */
(function () {
  "use strict";

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function scrollBehavior() {
    return prefersReducedMotion() ? "auto" : "smooth";
  }

  /* Camada de modal: trava o scroll da página, prende o foco e volta o foco ao fechar. */
  function createOverlay(modal, dialog, onClose) {
    var lastFocus = null;

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    function onKeydown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        close();
        return;
      }
      if (event.key !== "Tab") return;
      var items = focusables();
      if (!items.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("kjv-noScroll");
      document.addEventListener("keydown", onKeydown, true);
      var items = focusables();
      (items[0] || dialog).focus();
    }

    function close() {
      if (modal.hidden) return;
      if (typeof onClose === "function") onClose();
      modal.hidden = true;
      document.body.classList.remove("kjv-noScroll");
      document.removeEventListener("keydown", onKeydown, true);
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    return { open: open, close: close };
  }

  /* Modal de vídeo -------------------------------------------------------- */

  function initVideo(section) {
    if (section.dataset.kjvHomeReady === "1") return;

    var button = section.querySelector("[data-kjv-home-video-open]");
    var modal = section.querySelector("[data-kjv-home-video-modal]");
    var dialog = modal && modal.querySelector(".kjv-modal__box");
    var frame = modal && modal.querySelector("[data-kjv-home-video-frame]");
    if (!button || !modal || !dialog || !frame) return;
    section.dataset.kjvHomeReady = "1";

    if (!dialog.hasAttribute("tabindex")) dialog.setAttribute("tabindex", "-1");

    var overlay = createOverlay(modal, dialog, function () {
      frame.textContent = "";
    });

    button.addEventListener("click", function () {
      var src = button.getAttribute("data-kjv-home-video-src");
      if (!src) return;
      frame.textContent = "";
      var video = document.createElement("video");
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      frame.appendChild(video);
      overlay.open();
    });

    Array.prototype.forEach.call(modal.querySelectorAll("[data-kjv-home-video-close]"), function (el) {
      el.addEventListener("click", overlay.close);
    });
  }

  /* Galeria do produto em destaque ---------------------------------------- */

  function initGallery(gallery) {
    if (gallery.dataset.kjvHomeReady === "1") return;
    gallery.dataset.kjvHomeReady = "1";

    var slides = gallery.querySelector("[data-kjv-home-slides]");
    var thumbList = gallery.querySelector("[data-kjv-home-thumbs]");
    var thumbs = thumbList ? Array.prototype.slice.call(thumbList.querySelectorAll("[data-kjv-home-thumb]")) : [];
    if (!slides) return;

    var prevButton = gallery.querySelector(".kjv-prod__thumbArrow--prev");
    var nextButton = gallery.querySelector(".kjv-prod__thumbArrow--next");
    var current = 0;

    function isVertical() {
      return !!thumbList && thumbList.scrollHeight > thumbList.clientHeight + 1;
    }

    function updateArrows() {
      if (!thumbList) return;
      if (prevButton) prevButton.disabled = thumbList.scrollLeft <= 1;
      if (nextButton) {
        nextButton.disabled = thumbList.scrollLeft + thumbList.clientWidth >= thumbList.scrollWidth - 1;
      }
    }

    function revealThumb(index) {
      if (!thumbList || !thumbs[index]) return;
      var item = thumbs[index].parentElement;
      if (isVertical()) {
        if (item.offsetTop < thumbList.scrollTop || item.offsetTop + item.offsetHeight > thumbList.scrollTop + thumbList.clientHeight) {
          thumbList.scrollTo({ top: item.offsetTop, behavior: scrollBehavior() });
        }
      } else if (
        item.offsetLeft < thumbList.scrollLeft ||
        item.offsetLeft + item.offsetWidth > thumbList.scrollLeft + thumbList.clientWidth
      ) {
        thumbList.scrollTo({ left: item.offsetLeft, behavior: scrollBehavior() });
      }
    }

    function setActive(index) {
      current = index;
      thumbs.forEach(function (thumb, position) {
        var active = position === index;
        thumb.classList.toggle("is-active", active);
        thumb.setAttribute("aria-current", active ? "true" : "false");
      });
    }

    function goTo(index) {
      if (index < 0 || index >= slides.children.length) return;
      slides.scrollTo({ left: index * slides.clientWidth, behavior: scrollBehavior() });
      setActive(index);
      revealThumb(index);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        goTo(Number(thumb.dataset.kjvHomeThumb) || 0);
      });
    });

    Array.prototype.forEach.call(gallery.querySelectorAll("[data-kjv-home-thumb-step]"), function (button) {
      button.addEventListener("click", function () {
        if (!thumbList || !thumbs.length) return;
        var item = thumbs[0].parentElement;
        var step = Number(button.dataset.kjvHomeThumbStep) || 1;
        var size = item.offsetWidth + 8;
        thumbList.scrollTo({ left: thumbList.scrollLeft + step * size, behavior: scrollBehavior() });
      });
    });

    var pending = false;
    slides.addEventListener("scroll", function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        var width = slides.clientWidth || 1;
        var index = Math.round(slides.scrollLeft / width);
        if (index !== current) {
          setActive(index);
          revealThumb(index);
        }
      });
    });

    if (thumbList) thumbList.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    setActive(0);
    updateArrows();
  }

  /* Lightbox da galeria ---------------------------------------------------- */

  function initLightbox(modal) {
    if (modal.dataset.kjvHomeReady === "1") return;
    var dialog = modal.querySelector(".kjv-prod__lightboxBox");
    var scroll = modal.querySelector("[data-kjv-home-lightbox-scroll]");
    if (!dialog || !scroll) return;
    modal.dataset.kjvHomeReady = "1";

    if (!dialog.hasAttribute("tabindex")) dialog.setAttribute("tabindex", "-1");
    var overlay = createOverlay(modal, dialog);

    var owner = modal.closest(".kjv-prod") || document;
    Array.prototype.forEach.call(owner.querySelectorAll("[data-kjv-home-zoom]"), function (button) {
      button.addEventListener("click", function () {
        overlay.open();
        var item = scroll.querySelector('[data-kjv-home-lightbox-item="' + (Number(button.dataset.kjvHomeZoom) || 0) + '"]');
        if (item) {
          // Abre já na imagem clicada, sem a animação de rolagem.
          var antes = scroll.style.scrollBehavior;
          scroll.style.scrollBehavior = "auto";
          scroll.scrollTop = item.offsetTop;
          scroll.style.scrollBehavior = antes;
        }
      });
    });

    Array.prototype.forEach.call(modal.querySelectorAll("[data-kjv-home-lightbox-close]"), function (el) {
      el.addEventListener("click", overlay.close);
    });
  }

  /* Stepper de quantidade -------------------------------------------------- */

  function initQuantity(root) {
    Array.prototype.forEach.call(root.querySelectorAll("[data-kjv-home-qty]"), function (wrapper) {
      if (wrapper.dataset.kjvHomeReady === "1") return;
      wrapper.dataset.kjvHomeReady = "1";

      var input = wrapper.querySelector("[data-kjv-home-qty-input]");
      var buttons = Array.prototype.slice.call(wrapper.querySelectorAll("[data-kjv-home-qty-step]"));
      if (!input) return;

      function sync() {
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 1) value = 1;
        if (String(value) !== input.value) input.value = value;
        buttons.forEach(function (button) {
          if (Number(button.dataset.kjvHomeQtyStep) < 0) button.disabled = value <= 1;
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          var value = parseInt(input.value, 10);
          if (isNaN(value)) value = 1;
          value += Number(button.dataset.kjvHomeQtyStep) || 0;
          input.value = value < 1 ? 1 : value;
          sync();
        });
      });

      input.addEventListener("change", sync);
      input.addEventListener("blur", sync);
      sync();
    });
  }

  /* Compartilhar ----------------------------------------------------------- */

  function initShare(root) {
    Array.prototype.forEach.call(root.querySelectorAll("[data-kjv-home-share]"), function (wrapper) {
      if (wrapper.dataset.kjvHomeReady === "1") return;
      wrapper.dataset.kjvHomeReady = "1";

      var toggle = wrapper.querySelector("[data-kjv-home-share-toggle]");
      var panel = wrapper.querySelector(".kjv-prod__sharePanel");
      var input = wrapper.querySelector(".kjv-prod__shareInput");
      var message = wrapper.querySelector("[data-kjv-home-share-message]");
      var copyButton = wrapper.querySelector("[data-kjv-home-share-copy]");
      var closeButton = wrapper.querySelector("[data-kjv-home-share-close]");
      var url = wrapper.dataset.kjvHomeShareUrl || window.location.href;
      if (!toggle || !panel) return;

      var caixa = wrapper.querySelector(".kjv-prod__shareDetails");

      function setOpen(open) {
        if (caixa) caixa.open = open;
        else panel.hidden = !open;
        if (open && input) input.focus();
      }

      toggle.addEventListener("click", function (evento) {
        // No celular o sistema tem a própria folha de compartilhamento: usa ela e não abre o painel.
        if (navigator.share) {
          evento.preventDefault();
          navigator.share({ title: wrapper.dataset.kjvHomeShareTitle || document.title, url: url }).catch(function () {});
          return;
        }
        // Sem <details> (fallback), o clique abre e fecha o painel na mão.
        if (!caixa) {
          evento.preventDefault();
          setOpen(panel.hidden);
        }
      });

      if (caixa && input) {
        caixa.addEventListener("toggle", function () {
          if (caixa.open) input.focus();
        });
      }

      if (input) input.addEventListener("click", function () { input.select(); });

      if (closeButton) {
        closeButton.addEventListener("click", function () {
          setOpen(false);
          toggle.focus();
        });
      }

      if (copyButton) {
        copyButton.addEventListener("click", function () {
          var done = function () {
            if (!message) return;
            message.textContent = wrapper.dataset.kjvHomeShareCopied || "";
            window.setTimeout(function () {
              message.textContent = "";
            }, 3000);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done, done);
          } else if (input) {
            input.select();
            done();
          }
        });
      }

      document.addEventListener("pointerdown", function (event) {
        if (!panel.hidden && !wrapper.contains(event.target)) setOpen(false);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !panel.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function each(scope, selector, callback) {
    Array.prototype.forEach.call(scope.querySelectorAll(selector), callback);
  }

  function init(root) {
    var scope = root || document;
    each(scope, "[data-kjv-home-video-section]", initVideo);
    each(scope, "[data-kjv-home-gallery]", initGallery);
    each(scope, "[data-kjv-home-lightbox]", initLightbox);
    initQuantity(scope);
    initShare(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target || document);
  });
})();
